module.exports = __webpack_public_path__ + "static/Mark_Minden_headshot_lores-a2193adcb148e670c24e58d5bd3e2762.png";